import React from 'react';
import Button from '@material-ui/core/Button';
import { ValidatorForm } from 'react-material-ui-form-validator';
import apiClient, { getAccessToken } from '../../apiClient';
import './TargetPrice.scss';
import { withRouter } from 'react-router-dom';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TextField, TableSortLabel } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import withFlashNotification from '../Notification/withFlashNotification';
import { notifyApiError } from '../Notification/notificationHelpers';

function targetPriceQtyIsPositive(qty) {
  const n = Number(qty ?? 0);
  if (!Number.isFinite(n)) return false;
  const normalized = n === 0 ? 0 : n;
  return parseFloat(normalized.toFixed(2)) > 0;
}

 class TargetPrice extends React.Component {
  
    state = {
        Results: [],
        tableSearch: '',
        itemsPage: 0,
        itemsRowsPerPage: 10,
        totalItemCount: 0,
        itemsSortColumn: null,
        itemsSortDirection: 'asc',
        /** ItemId (number) -> edited target price string (persists across pages until submit) */
        pendingTargetEdits: {},
        columns: [
            { title: 'PermissionName', field: 'PermissionName' },
            { title: 'PermissionAllowed', field: 'PermissionAllowed', editable: true,
            editComponent: (props) => (
              <input
                type="checkbox"
                checked={props.value}
                onChange={(e) => props.onChange(e.target.checked)}
              />
            ),
            render: (rowData) => (
              <input type="checkbox" checked={rowData.PermissionAllowed} disabled />
            )
          }
        ],
        headers: [
          { label: "Permission", key: "PermissionName" },
          { label: "PermissionAllowed", key: "PermissionAllowed" }
        ],
        roleList: [],
        formData: {
            rolePermissionId: 0,
            permission: '',
            permissionAllowed: ''
        },
        rollId:1,
        submitted: false,
        successMessage:null,
        errorMessage:null,
       
    }

    componentDidMount() {
        let accessToken = getAccessToken();
        try {
          const user = JSON.parse(sessionStorage.getItem('user'));
          accessToken = user && user.accessToken ? user.accessToken : '';
        } catch (e) { /* ignore */ }

        apiClient.get(`/api/get/role`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
          .then(res => {
            const roleList = res.data;
            this.setState({ roleList });
          })
          .catch(error => notifyApiError(
            this.props.showFlashNotification,
            error,
            'Unable to load roles.'
          ));

        this.fetchTargetPriceItems(0, this.state.itemsRowsPerPage, '');
      }

      componentWillUnmount() {
        if (this._targetPriceSearchTimer) {
          clearTimeout(this._targetPriceSearchTimer);
        }
      }

      fetchTargetPriceItems(page, pageSize, searchOverride) {
        const user = JSON.parse(sessionStorage.getItem('user'));
        const accessToken = user && user.accessToken ? user.accessToken : '';
        const search = searchOverride !== undefined ? searchOverride : this.state.tableSearch;
        const params = {
          page,
          pageSize,
          status: 'active',
          search: (search || '').trim(),
          quantityGtZero: 1,
        };
        if (this.state.itemsSortColumn) {
          params.sortBy = this.state.itemsSortColumn;
          params.sortDir = this.state.itemsSortDirection;
        }

        apiClient.get(`/api/get/item/paged`, {
          params,
          headers: { Authorization: `Bearer ${accessToken}` }
        })
          .then(res => {
            const rows = (res.data && res.data.items ? res.data.items : [])
              .filter((item) => targetPriceQtyIsPositive(item.Quantity));
            const totalItemCount = res.data && res.data.totalCount != null ? res.data.totalCount : 0;
            this.setState(prev => {
              const merged = rows.map(item => {
                const id = item.ItemId;
                if (Object.prototype.hasOwnProperty.call(prev.pendingTargetEdits, id)) {
                  return { ...item, TargetPrice: prev.pendingTargetEdits[id], IsChanged: 1 };
                }
                return { ...item, IsChanged: 0 };
              });
              return {
                Results: merged,
                totalItemCount,
                itemsPage: page,
                itemsRowsPerPage: pageSize
              };
            });
          })
          .catch(error => notifyApiError(
            this.props.showFlashNotification,
            error,
            'Unable to load target price items.'
          ));
      }

      componentPopulatePermissions(value) {
        this.fetchTargetPriceItems(0, this.state.itemsRowsPerPage, this.state.tableSearch);
      }

    handleChange = (event) => {
      this.state.rollId = event.target.value;
      this.componentPopulatePermissions(this.state.rollId);
      
    }

    handleSubmit = () => {
        let user = JSON.parse(sessionStorage.getItem('user'));
        let accessToken = user.accessToken;

        const pending = this.state.pendingTargetEdits || {};
        const results = Object.keys(pending).map((id) => ({
          ItemId: Number(id),
          TargetPrice: pending[id]
        }));

        if (results.length > 0) {
          apiClient.post(`/api/post/targetPriceUpdate`, { results }, { headers: {"Authorization" : `Bearer ${accessToken}`} })
            .then(() => {
              this.setState({ successMessage: 'Successfully saved!', pendingTargetEdits: {} });
              this.fetchTargetPriceItems(this.state.itemsPage, this.state.itemsRowsPerPage, this.state.tableSearch);

              setTimeout(() => {
                this.setState({ successMessage: null });
                sessionStorage.setItem('ItemTabIndex', JSON.stringify(1));
                const { history } = this.props;
                history.push('/vendor-details');
                setTimeout(() => {
                  history.push('/item-form');
                }, 1);
              }, 3000);
            })
            .catch((error) => {
              const message =
                error && error.response && error.response.data && error.response.data.error
                  ? error.response.data.error
                  : 'Unable to save target prices.';
              this.setState({ errorMessage: message, successMessage: null });
              this.props.showFlashNotification(message, 'error');
              setTimeout(() => this.setState({ errorMessage: null }), 8000);
            });
        }
    }

    handleChildClick = () => {
      this.props.onSendValue();
      };

      handleInputChange = (e, itemId) => {
        const value = e.target.value;
        this.setState(prev => {
          const pendingTargetEdits = { ...prev.pendingTargetEdits, [itemId]: value };
          const Results = prev.Results.map(item =>
            item.ItemId === itemId ? { ...item, TargetPrice: value, IsChanged: 1 } : item
          );
          return { pendingTargetEdits, Results };
        });
      };

      handleTableSearchChange = (e) => {
        const tableSearch = e.target.value;
        this.setState({ tableSearch, itemsPage: 0 });
        if (this._targetPriceSearchTimer) {
          clearTimeout(this._targetPriceSearchTimer);
        }
        this._targetPriceSearchTimer = setTimeout(() => {
          this.fetchTargetPriceItems(0, this.state.itemsRowsPerPage, tableSearch);
        }, 400);
      };

      handleTargetPricePageChange = (event, newPage) => {
        this.fetchTargetPriceItems(newPage, this.state.itemsRowsPerPage, this.state.tableSearch);
      };

      handleTargetPriceRowsPerPageChange = (event) => {
        const pageSize = parseInt(event.target.value, 10);
        this.fetchTargetPriceItems(0, pageSize, this.state.tableSearch);
      };

      handleTargetPriceSortClick = (columnId) => {
        this.setState(
          (prev) => {
            const same = prev.itemsSortColumn === columnId;
            return {
              itemsSortColumn: columnId,
              itemsSortDirection: same && prev.itemsSortDirection === 'asc' ? 'desc' : 'asc',
              itemsPage: 0,
            };
          },
          () => {
            this.fetchTargetPriceItems(0, this.state.itemsRowsPerPage, this.state.tableSearch);
          }
        );
      };

    render() {
      sessionStorage.setItem('TranSearch', null);
      
        const { submitted, Results, tableSearch, itemsPage, itemsRowsPerPage, totalItemCount } = this.state;

        return (
        <div className="TargetPrice">
          
                  
            <ValidatorForm style={{display:'none'}}
                ref="form"
               
            >
                           <h2>Target Price Form</h2>
                           <br/>

             <div style={{textAlign:'left', paddingBottom: '3px',marginTop:'5px',float:'left'}}>
                         
                              <TextField 
                              style= {{ backgroundColor: 'transparent' }}
                            label="Item"
                            variant="filled"
                      
                        InputLabelProps={{
                          style: { textAlign: 'left', backgroundColor: 'transparent' },
                          }}
                            name="ponumber"
                          />
               </div>

                <div style={{textAlign:'left', paddingBottom: '3px',marginTop:'5px',float:'left'}}>
          
            
          <Button
                       color="primary"
                       style= {{ width: '250px' , textAlign:'left'}}
                       variant="contained"
                   >
                       {
                            'Search'
                       }
                   </Button>
   
        
               </div>
               <br></br>
               <br></br>
               
                {this.state.successMessage && (
          <div
            style={{
              backgroundColor: '#28a745',
              color: '#fff',
              padding: '10px',
              marginTop: '10px',
            }}
          >
            {this.state.successMessage}
          </div>
        )}

{this.state.errorMessage && (
        <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px' }}>
          {this.state.errorMessage}
        </div>
      )}
            </ValidatorForm>


<div style={{ maxWidth: '100%', paddingTop: '50px' }}>
<div style={{textAlign:'right', paddingBottom: '15px'}}>

  <TextField
    className="targetPriceSearch"
    variant="filled"
    size="small"
    label="Search"
    placeholder="Search by item name or number..."
    style={{ backgroundColor: 'transparent' }}
    value={tableSearch}
    onChange={this.handleTableSearchChange}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon fontSize="small" />
        </InputAdornment>
      ),
      endAdornment: tableSearch ? (
        <InputAdornment position="end">
          <IconButton
            size="small"
            aria-label="clear search"
            onClick={() => {
              this.setState({ tableSearch: '', itemsPage: 0 });
              if (this._targetPriceSearchTimer) {
                clearTimeout(this._targetPriceSearchTimer);
              }
              this.fetchTargetPriceItems(0, this.state.itemsRowsPerPage, '');
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </InputAdornment>
      ) : null,
    }}
  />
</div>

<TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
                active={this.state.itemsSortColumn === 'ItemNumber'}
                direction={this.state.itemsSortColumn === 'ItemNumber' ? this.state.itemsSortDirection : 'asc'}
                onClick={() => this.handleTargetPriceSortClick('ItemNumber')}
              >
                Item Number
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={this.state.itemsSortColumn === 'ItemName'}
                direction={this.state.itemsSortColumn === 'ItemName' ? this.state.itemsSortDirection : 'asc'}
                onClick={() => this.handleTargetPriceSortClick('ItemName')}
              >
                Item Name
              </TableSortLabel>
            </TableCell>
            <TableCell align="right">
              <TableSortLabel
                style={{ flexDirection: 'row-reverse' }}
                active={this.state.itemsSortColumn === 'Quantity'}
                direction={this.state.itemsSortColumn === 'Quantity' ? this.state.itemsSortDirection : 'asc'}
                onClick={() => this.handleTargetPriceSortClick('Quantity')}
              >
                Quantity
              </TableSortLabel>
            </TableCell>
            <TableCell align="right">
              <TableSortLabel
                style={{ flexDirection: 'row-reverse' }}
                active={this.state.itemsSortColumn === 'Cost'}
                direction={this.state.itemsSortColumn === 'Cost' ? this.state.itemsSortDirection : 'asc'}
                onClick={() => this.handleTargetPriceSortClick('Cost')}
              >
                Cost
              </TableSortLabel>
            </TableCell>
            <TableCell align="center">
              <TableSortLabel
                active={this.state.itemsSortColumn === 'TargetPrice'}
                direction={this.state.itemsSortColumn === 'TargetPrice' ? this.state.itemsSortDirection : 'asc'}
                onClick={() => this.handleTargetPriceSortClick('TargetPrice')}
              >
                Target Price
              </TableSortLabel>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(Results || []).map(item => (
            <TableRow key={item.ItemId}>
              <TableCell>{item.ItemNumber}</TableCell>
              <TableCell>{item.ItemName}</TableCell>
              <TableCell align="right">{parseFloat(item.Quantity || 0).toFixed(2)}</TableCell>
              <TableCell align="right">{parseFloat(item.Cost || 0).toFixed(2)}</TableCell>
              <TableCell align="center">
              <TextField
              type="Number"
              style={{   textAlign:"right" }}
              value={item.TargetPrice != null && item.TargetPrice !== '' ? item.TargetPrice : ''}
                          onChange={(e) => this.handleInputChange(e, item.ItemId)} 
                        />
               
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    <TablePagination
      component="div"
      count={totalItemCount}
      page={itemsPage}
      onChangePage={this.handleTargetPricePageChange}
      rowsPerPage={itemsRowsPerPage}
      onChangeRowsPerPage={this.handleTargetPriceRowsPerPageChange}
      rowsPerPageOptions={[5, 10, 20, 50]}
    />

    <br /><br />
   
<Button
onClick={this.handleSubmit}
 color="primary"
 variant="contained"
 type="button"
 disabled={submitted}
>
 Submit
</Button>

    
               
                
                {this.state.successMessage && (
          <div
            style={{
              backgroundColor: '#28a745',
              color: '#fff',
              padding: '10px',
              marginTop: '10px',
            }}
          >
            {this.state.successMessage}
          </div>
        )}
              




</div>


          
         </div>
        
        );
    }
}
export default withRouter(withFlashNotification(TargetPrice));
